module.exports = __webpack_public_path__ + "img/sketch_new_consultant.a5e3d5d9.png";